import z from 'zod';

//* Define your environment variables schema here, so you get type safety throughout your app
export const EnvSchema = z.object({
  API_BASE_URL: z.string(),
  ENABLED_LANGUAGES: z.string(),
  GAMEZONE_URL: z.string(),
  TENANT: z.string(),
  BANNER_BASE_URL: z.string(),
  FEATURE_NON_LOGIN_ENABLED: z
    .string()
    .refine((s) => s === 'true' || s === 'false')
    .transform((s) => s === 'true'),

  GLITCH_TIP_DSN: z.string().optional(),
  GTM_TOKEN: z.string().optional(),
  GTAG_ENABLED: z
    .string()
    .refine((s) => s === 'true' || s === 'false')
    .transform((s) => s === 'true')
    .optional(),
});
